import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  padding-top: 10px;
`;
